import React from 'react';
import AppointmentCard from 'components/organisms/appointment-details/components/appointment-card';
import MonthlyAppointmentTable from 'components/organisms/appointment-details/components/mothly-appointment-table';
import BaseGrid from 'components/atoms/base-grid';

interface IProps {
  patientGuid: string;
}

const CallDashboardAppointmentTab: React.FC<IProps> = (props) => {
  const { patientGuid } = props;

  return (
    <BaseGrid rowGap={40}>
      <AppointmentCard patientGuid={patientGuid} />
      <MonthlyAppointmentTable patientGuid={patientGuid} />
    </BaseGrid>
  );
};

export default CallDashboardAppointmentTab;
